export default {
    namespaced: true,
    state: {
        isActive : false,
    },
    mutations: {
        toggleActive(state) {
            state.isActive = true;
        },
        toggleInactive(state) {
            state.isActive = false;
        }
    },
    actions: {
        toggleErrorState({commit, state}) {
            if(!state.isActive) {
                commit('toggleActive');
            } else {
                commit('toggleInactive');
            }
        }
    }
}